// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__27FRO","footer":"ModalCreateQualiphyProcedure_footer__2De1I","additionData":"ModalCreateQualiphyProcedure_additionData__rfaK4"};